export default __webpack_public_path__ + "static/media/280.0add0cb8.jpg";